import styled from 'styled-components'
import { Panel } from 'ui/components/Panel'

export const PanelWithMargin = styled(Panel)`
  margin-bottom: 70px;
`
